import axios from 'axios';
import { api } from '../../utils/Constants';
import { updateAxiosToken } from './apiService';

export async function sendDriverSms(tripId) {
  await updateAxiosToken();
  const url = `${api.url}${api.methods.driverCallMessage}/driver-call-message/${tripId}`;

  const response = await axios.post(url);
  return response;
}
